import get from 'lodash.get';
import { createSelector } from 'reselect';

import { emptyArray, emptyObject } from '../../../default-props/empty';

export const selectBatch = (state) => get(state, 'batch', emptyObject);
export const selectAppliedFilters = (state) => get(state, 'appliedFilters', emptyArray);
export const selectIsLoading = (state) => get(state, 'isLoading');
export const selectMoveToBatchModalId = (state) => get(state, 'moveToBatchModalId');
export const selectAddressValidationJobs = (state) => get(state, 'addressValidationJobs', emptyArray);
export const selectSelectedViewId = (state) => get(state, 'selectedViewId');
export const selectRateBatchJobs = (state) => get(state, 'rateBatchJobs', emptyArray);
export const selectShipmentNotificationJobs = (state) => get(state, 'shipmentNotificationJobs', emptyArray);
export const selectHasNameConflict = (state) => get(state, 'hasNameConflict');
export const selectFulfillmentPlanSetId = (state) => get(state, 'batch.fulfillmentPlanSetId');
export const selectBatchReceivingFulfillmentPlans = (state) => get(state, 'batchReceivingFulfillmentPlans');

export const selectIsAddingToBatch = createSelector(
  selectBatchReceivingFulfillmentPlans,
  (batchReceivingFulfillmentPlans) => !!batchReceivingFulfillmentPlans,
);
